import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';

export function MDS({data, MDSDataReady, customPostcode, setCustomPostcode, getData, classes, style, SPID}) {
    const [postcodeModal, setPostcodeModal] = useState(false);
    const [sortedColumn, setSortedColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');
    const [triggerGetData, setTriggerGetData] = useState(false);
    const handleSort = (columnName) => {
        if (sortedColumn === columnName) {
          setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
          setSortedColumn(columnName);
          setSortDirection('asc');
        }
      };

      const handleGetData = () => {
        setCustomPostcode(''); 
        setTriggerGetData(true);
    };

    useEffect(() => {
        if (triggerGetData) {
            getData();
            setTriggerGetData(false);
        }
    }, [customPostcode, triggerGetData]);
    return (
        <div style={{overflowY: 'auto', maxHeight: '70vh'}}>
            <table className={`table borders scale-text` + classes ?? ''} style={{ ...style, tableLayout: 'fixed' }}>
            <thead style={{position: 'sticky', top: '0px'}}>
                <tr>
                    <th style={{textAlign: 'start' }} colSpan= '1' >
                        SPID
                        </th>
                    <th onClick={() => handleSort("Customer_Name")} style={{textAlign: 'start' }} colSpan= '1' >
                        Customer Name
                    </th>
                    <th style={{textAlign: 'start' }} colSpan= '1' >
                        UPRN
                    </th>            
                    <th style={{textAlign: 'start' }} colSpan= '1' >
                        VOA BA Reference
                    </th>
                    <th style={{textAlign: 'start' }} colSpan= '1' >
                        SAO
                    </th>
                    <th style={{textAlign: 'start' }} colSpan= '1' >
                        PAO
                    </th>
                    <th onClick={() => handleSort("Premises_Address_Address_Line_1")} style={{textAlign: 'start' }} colSpan= '1' >
                        Address 1
                    </th>
                    <th style={{textAlign: 'start' }} colSpan= '1' >
                        Address 2
                    </th>
                    <th style={{textAlign: 'start' }} colSpan= '1' >
                        Address 3
                    </th>
                    <th style={{textAlign: 'start' }} colSpan= '1' >
                        Address 4
                    </th>
                    <th style={{textAlign: 'start' }} colSpan= '1' >
                        Address 5
                    </th>
                    <th style={{textAlign: 'start' }} colSpan= '1' >
                        {
                            setCustomPostcode ? 
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    Address - Postcode
                                    <div style={{ marginLeft: 'auto', display: 'flex', gap: 10 }}>
                                    {customPostcode && (
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        <span className='fas fa-trash-undo' onClick={() => { handleGetData() }} title="Restore original postcode search"></span>
                                        </div>
                                    )}
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        <span className='fas fa-search' onClick={() => setPostcodeModal(true)} title="Search for a different postcode"></span>
                                    </div>
                                    </div>
                                </div>
                            :
                                "Postcode"
                        }
                    </th>
                </tr>
                </thead>
                <tbody>
                {
                    MDSDataReady === true ? (
                        data && data.length ? (
                        data
                        .sort((a, b) => {
                            const coreA = a.SPID.match(/^\d+/)[0];
                            const coreB = b.SPID.match(/^\d+/)[0];
                          
                            const aMatches = a.SPID.startsWith(SPID);
                            const bMatches = b.SPID.startsWith(SPID);
                            
                            if (aMatches && !bMatches) return -1;
                            if (!aMatches && bMatches) return 1;
                          
                            if (coreA !== coreB) return parseInt(coreA) - parseInt(coreB);
                          
                            const aLetter = a.SPID.includes('W') ? 'W' : 'S';
                            const bLetter = b.SPID.includes('W') ? 'W' : 'S';
                          
                            if (aLetter !== bLetter) {
                              return aLetter === 'W' ? -1 : 1;
                            }
                          
                            const aNumber = parseInt(a.SPID.replace(/\D/g, ''), 10);
                            const bNumber = parseInt(b.SPID.replace(/\D/g, ''), 10);
                          
                            return aNumber - bNumber;
                          })
                        .map((row, index) => (
                            <tr key={index}>
                            <td>{row.SPID}</td>
                            <td>{row.Customer_Name}</td>
                            <td>{row.UPRN}</td>
                            <td>{row.VOA_BA_Reference}</td>
                            <td>{row.Premises_Address_Secondary_Address_Obj}</td>
                            <td>{row.Premises_Address_Primary_Address_Obj}</td>
                            <td>{row.Premises_Address_Address_Line_1}</td>
                            <td>{row.Premises_Address_Address_Line_2}</td>
                            <td>{row.Premises_Address_Address_Line_3}</td>
                            <td>{row.Premises_Address_Address_Line_4}</td>
                            <td>{row.Premises_Address_Address_Line_5}</td>
                            <td>{row.Premises_Address_Postcode}</td>
                            </tr>
                        ))
                        ) : (
                            <tr>
                                <td>{data?.SPID || ''}</td>
                                <td>{data?.Customer_Name || ''}</td>
                                <td>{data?.UPRN || ''}</td>
                                <td>{data?.VOA_BA_Reference || ''}</td>
                                <td>{data?.Premises_Address_Secondary_Address_Obj || ''}</td>
                                <td>{data?.Premises_Address_Primary_Address_Obj || ''}</td>
                                <td>{data?.Premises_Address_Address_Line_1 || ''}</td>
                                <td>{data?.Premises_Address_Address_Line_2 || ''}</td>
                                <td>{data?.Premises_Address_Address_Line_3 || ''}</td>
                                <td>{data?.Premises_Address_Address_Line_4 || ''}</td>
                                <td>{data?.Premises_Address_Address_Line_5 || ''}</td>
                                <td>{data?.Premises_Address_Postcode || ''}</td>
                            </tr>
                        )
                    ) : (
                        <i className="fa fa-spinner fa-spin"></i>
                    )
                }
                </tbody>
                <ReactModal
                isOpen={postcodeModal}
                onRequestClose={() => setPostcodeModal(false)}
                className="card bulk-allocate"
                contentLabel="Bulk Allocate COT Alert Data"
                style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <h3>Postcode Search</h3>
                        <input value={customPostcode ? customPostcode : data?.[0]?.Premises_Address_Postcode} onChange={_ => setCustomPostcode(_.target.value.toUpperCase())} style={{ border: '1px solid gray', width: '100%', borderRadius: 3 }} />
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                        <button className={`button compact smaller-text ${customPostcode?.length >= 3 ? 'background-primary colour-white' : ''}`} disabled={customPostcode?.length < 3} onClick={() => { getData(customPostcode); setPostcodeModal(false); }}>Search</button>
                        </div>
                    </div>
                </ReactModal>
            </table>
        </div>
    )
}